module.exports = __webpack_public_path__ + "data/app.developer.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/developer/app.developer.json
// module id = 2ZN7
// module chunks = 1